

import { Spots } from '../Spots'
import { Spot, SpotModelViewDto } from '../spot/Spot'

import { FlyerPageSpotDto } from '../../../../../dtos';

import { SpotsCollisionManager } from '../collisionManagers/SpotsCollisionManager';
import { CustomDataEvent } from '../../../../../globals/CustomDataEvent';
import { Boundries } from '../../../../../globals/Boundries';


export class SpotsTranslationManager {

    private _mainSpotsContainer: Spots | null = null;

    private _collisionManager: SpotsCollisionManager | null = null;

    constructor(spotsContainer: Spots) {
        this._mainSpotsContainer = spotsContainer;
        this._collisionManager = new SpotsCollisionManager();
    }

    private preMove(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if (selectedSpots.length === 0) {
            return;
        }

        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;
        mouseEvent.stopPropagation();

        if (!mainContainer.isInMoveSpotsMode) {
            mainContainer.isInMoveSpotsMode = true;

            var mouseX = mouseEvent.stageX;
            var mouseY = mouseEvent.stageY;
            mainContainer.mouseX0 = spot.x
            mainContainer.mouseY0 = spot.y
            mainContainer.lastMouseX = mouseX;
            mainContainer.lastMouseY = mouseY;
            mainContainer.translationOffsetX = mouseX - spot.x;
            mainContainer.translationOffsetY = mouseY - spot.y;

            let spotsDtos: SpotModelViewDto[] = []
            mainContainer.currentSelectedSpotsDtos = spotsDtos;

            for (let i = 0; i < selectedSpots.length; i++) {
                const currentSpot = selectedSpots[i];

                // VERY IMPORTANT
                currentSpot.updateOriginalDImensions();

                const currentSpotBounds = currentSpot.getBounds();

                let x0 = currentSpot.x;
                let y0 = currentSpot.y;

                let spotDto: FlyerPageSpotDto | null;

                if (currentSpot.initialData) {
                    spotDto = currentSpot.initialData
                }
                else {
                    spotDto = {
                        fpsX0px: x0,
                        fpsY0px: y0,
                        fpsWidthPx: currentSpotBounds.width,
                        fpsHeightPx: currentSpotBounds.height
                    }
                }

                currentSpot.initialData = spotDto

                let mvDto = { dto: spotDto, spot: currentSpot }

                if (spot === currentSpot) {
                    mainContainer.currentSelectedSpotScallerDto = mvDto
                }

                spotsDtos.push(mvDto)

            }
        }
    }

    public moveSelectedSpots (event: CustomDataEvent) {
        let mainContainer = this._mainSpotsContainer!

        if (mainContainer.innerSpots.length === 0) {
            return;
        }

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if (selectedSpots.length === 0) {
            return;
        }

        this.preMoveFromKeyboard(event);

        //

        //
        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!
        let boundriesCorrectors: Boundries[] = []

        let hasBordersCollisions = false;
        //
        //

        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!

                switch (event.type) {
                    case "arrowleft": {
                        spot!.x = spot!.x - 1;
                        break;
                    }
                    case "arrowright": {
                        spot!.x = spot!.x + 1;
                        break;
                    }
                    case "arrowup": {
                        spot!.y = spot!.y - 1;
                        break;
                    }
                    case "arrowdown": {
                        spot!.y = spot!.y + 1;
                        break;
                    }
                }
                if(this._collisionManager!.hasPassedAnyBorder(spot)){
                    hasBordersCollisions = true;
                    let boundriesCorrectorItem = this._collisionManager!.getBoundariesToRetriveToAvoidCanvasBorders(spot)
                    boundriesCorrectors.push(boundriesCorrectorItem);
                }
        }
        if(boundriesCorrectors) {
            this.updateSpotsWithBoundriesCorrector(seleectedSpotsDto, boundriesCorrectors)
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unselectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForMovingSelectedSpots(currentSpots, unselectedSpots);

        mainContainer.updateStage()

        // if no frames selected
    }


    private preMoveFromKeyboard(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if (selectedSpots.length === 0) {
            return;
        }


        if (!mainContainer.isInMoveSpotsMode) {
            mainContainer.isInMoveSpotsMode = true;


            let spotsDtos: SpotModelViewDto[] = []
            mainContainer.currentSelectedSpotsDtos = spotsDtos;

            for (let i = 0; i < selectedSpots.length; i++) {
                const currentSpot = selectedSpots[i];

                // VERY IMPORTANT
                currentSpot.updateOriginalDImensions();

                const currentSpotBounds = currentSpot.getBounds();

                let x0 = currentSpot.x;
                let y0 = currentSpot.y;

                let spotDto: FlyerPageSpotDto | null;

                if (currentSpot.initialData) {
                    spotDto = currentSpot.initialData
                }
                else {
                    spotDto = {
                        fpsX0px: x0,
                        fpsY0px: y0,
                        fpsWidthPx: currentSpotBounds.width,
                        fpsHeightPx: currentSpotBounds.height
                    }
                }

                currentSpot.initialData = spotDto

                let mvDto = { dto: spotDto, spot: currentSpot }
                spotsDtos.push(mvDto)

            }
        }
    }

    public liveMove(event: CustomDataEvent) {

        let mainContainer = this._mainSpotsContainer!

        if (mainContainer.innerSpots.length === 0) {
            return;
        }

        let selectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        if (selectedSpots.length === 0) {
            return;
        }

        this.preMove(event);

        //
        let data = event.data;
        let spot = data.spot;
        let mouseEvent = data.mouseEvent;

        mainContainer.currentMouseX = mouseEvent.stageX;
        mainContainer.currentMouseY = mouseEvent.stageY;

        let generatedWidth = mainContainer.currentMouseX - mainContainer.mouseX0
        let generatedHeight = mainContainer.currentMouseY - mainContainer.mouseY0

        mainContainer.lastMouseX = mainContainer.currentMouseX
        mainContainer.lastMouseY = mainContainer.currentMouseY

        //
        let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!
        let boundriesCorrectors: Boundries[] = []

        let hasBordersCollisions = false;
        for (let i = 0; i < seleectedSpotsDto.length; i++) {
            let item = seleectedSpotsDto[i];
            const spot = item.spot!
            const spotDto = item.dto!;

            let nextX = spotDto.fpsX0px! + generatedWidth - mainContainer.translationOffsetX 
            let nextY = spotDto.fpsY0px! + generatedHeight - mainContainer.translationOffsetY

            // console.log(generatedWidth, generatedHeight, nextX, nextY)

            // individual spots
            spot.x = nextX
            spot.y = nextY

            if(this._collisionManager!.hasPassedAnyBorder(spot)){
                hasBordersCollisions = true;
                let boundriesCorrectorItem = this._collisionManager!.getBoundariesToRetriveToAvoidCanvasBorders(spot)
                boundriesCorrectors.push(boundriesCorrectorItem);
            }
        }

        //
        if(boundriesCorrectors) {
            this.updateSpotsWithBoundriesCorrector(seleectedSpotsDto, boundriesCorrectors)
        }

        //
        let currentSpots = mainContainer.spotsFunctions!.getSelectedSpots(true);
        let unselectedSpots = mainContainer.spotsFunctions!.getSelectedSpots(false);
        this.handleCollisionsStateForMovingSelectedSpots(currentSpots, unselectedSpots);

        mainContainer.updateStage()
    }

    private updateSpotsWithBoundriesCorrector(seleectedSpotsDto: SpotModelViewDto[], boundriesCorrectors: Boundries[]){

        let deltaX: number = 0;
        let deltaY: number = 0;

        for (let i = 0; i < boundriesCorrectors.length; i++) 
        {
            const boundriesItem: Boundries = boundriesCorrectors[i];
            boundriesItem.retrieve(deltaX, deltaY);

            deltaX += boundriesItem.left! + boundriesItem.right!
            deltaY += boundriesItem.top! + boundriesItem.bottom!

            for (let j = 0; j < seleectedSpotsDto.length; j++) {
                let item = seleectedSpotsDto[j];
                const spot = item.spot!
                const spotDto = item.dto!;
    
                spot.x += boundriesItem!.left!;
                spot.x -= boundriesItem!.right!;

                spot.y += boundriesItem!.top!;
                spot.y -= boundriesItem!.bottom!;
            }
        }
    }

    private handleCollisionsStateForMovingSelectedSpots(currentSpots: Spot[], otherSpots: Spot[]){
        let mainContainer = this._mainSpotsContainer!;

        let hasCollisions = this._collisionManager?.hasCollisionsBetweenSpots(currentSpots, otherSpots)
        if(hasCollisions) {
            console.log(`hasCollisions: ${hasCollisions}`)
            mainContainer.isInCollisionState = true;
            mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
            mainContainer.canvasMouseTracker!.showMouseIcon('noAccessIcon', true);
        }
        else {
            mainContainer.isInCollisionState = false;
            mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
            mainContainer.canvasMouseTracker!.showMouseIcon('moveFramesIcon', true);
        }
    }

    public handleScallingMouseUpForMovedSpots(){
        let mainContainer = this._mainSpotsContainer!

        let selectedSpots = mainContainer.currentSelectedSpotsDtos!.map(mvDto =>  mvDto.spot! )
        let unSelectedSpots =  mainContainer.spotsFunctions!.getSelectedSpots(false);
        let hasCollisions = this._collisionManager!.hasCollisionsBetweenSpots(selectedSpots, unSelectedSpots)

        if(hasCollisions) {
            // let currentSelectedSpotScallerDto = mainContainer.currentSelectedSpotScallerDto;
            // let currentSelectedSpotScallerSpotDto = currentSelectedSpotScallerDto!.dto!;

            let seleectedSpotsDto = mainContainer.currentSelectedSpotsDtos!

            for (let i = 0; i < seleectedSpotsDto.length; i++) {
                let item = seleectedSpotsDto[i];
                const spot = item.spot!
                const spotDto = item.dto!;

                // individual spots
                spot.x = spotDto.fpsX0px!;
                spot.y = spotDto.fpsY0px!;
            }

            mainContainer.updateStage();
        }
        else {
            //
            let selectedSpots = mainContainer.spotsFunctions?.getSelectedSpots(true);
            let updatedSpotsDtos: FlyerPageSpotDto[] = selectedSpots!.map(spot => {
                return spot.updatedData;
            })
            mainContainer.persistenceManager?.prepareSpotsForSaving(updatedSpotsDtos);
        }
        mainContainer.canvasMouseTracker!.hideIcon('moveFramesIcon');
        mainContainer.canvasMouseTracker!.hideIcon('noAccessIcon');
    }

}